export default "__VITE_ASSET__BLk_vKPr__"